import * as Sentry from '@sentry/react'
import { RouterStore } from '@superwf/mobx-react-router'
import { createBrowserHistory } from 'history'
import { Provider } from 'mobx-react'
import React, { useLayoutEffect, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'sonner'

import { Routes } from './pages/Routes'
import { init as initAnalytics } from './utils/analytics'

// The env variable is not converted to a bool - must check for the explicit string
if (import.meta.env.VITE_SENTRY_ENABLED === 'true') {
  Sentry.init({
    release: import.meta.env.VITE_SENTRY_RELEASE_GIT_HASH,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    // Keep Sentry replays error-only
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  })
}

// Initialize PostHog analytics
initAnalytics()

// Create mobx store with history
const browserHistory = createBrowserHistory()
const routingStore = new RouterStore(browserHistory)
const stores = {
  routing: routingStore,
}

const RefreshBrowserRouter = ({ ...rest }) => <BrowserRouter {...rest} />

function App() {
  // State
  const [history, setHistory] = useState({
    action: routingStore.history.action,
    location: routingStore.history.location,
  })

  useLayoutEffect(() => routingStore.subscribe(setHistory), [])

  return (
    <Provider {...stores}>
      <Toaster position="top-center" visibleToasts={3} gap={10} />
      <RefreshBrowserRouter
        location={history.location}
        navigationType={history.action}
        navigator={routingStore.history}
      >
        <Routes />
      </RefreshBrowserRouter>
    </Provider>
  )
}

export default App
